import { Box, TableRow, Typography } from "@mui/material";
import React from "react";
import { NoDataTableCell } from "./NoDataTableRow.styles";
import { theme } from "../../theme";

const NoDataTableRow: React.FC<{
  message: string;
  collSpan: number;
}> = ({ message, collSpan }) => {
  return (
    <TableRow>
      <NoDataTableCell theme={theme} colSpan={collSpan}>
        <Box
          sx={{
            padding: 2,
          }}
        >
          <Typography>{message}</Typography>
        </Box>
      </NoDataTableCell>
    </TableRow>
  );
};

export default NoDataTableRow;
